var moduleMap = {
	"./MountRoles": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_gsap_index_js"), __webpack_require__.e("vendors-node_modules_css-loader_dist_runtime_api_js-node_modules_css-loader_dist_runtime_sour-493a42"), __webpack_require__.e("vendors-node_modules_react-router-dom_dist_index_js-node_modules_axios_lib_axios_js"), __webpack_require__.e("webpack_sharing_consume_default_react_react"), __webpack_require__.e("webpack_sharing_consume_default_react-dom_react-dom"), __webpack_require__.e("src_App_scss-src_ZeusDSConfig_index_tsx-src_router_dev-router_ts"), __webpack_require__.e("src_bootstrap_tsx")]).then(() => (() => ((__webpack_require__(/*! ./src/bootstrap */ "./src/bootstrap.tsx")))));
	},
	"./RolesMicrofrontend": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_gsap_index_js"), __webpack_require__.e("vendors-node_modules_css-loader_dist_runtime_api_js-node_modules_css-loader_dist_runtime_sour-493a42"), __webpack_require__.e("vendors-node_modules_react-router-dom_dist_index_js-node_modules_axios_lib_axios_js"), __webpack_require__.e("webpack_sharing_consume_default_react_react"), __webpack_require__.e("webpack_sharing_consume_default_react-dom_react-dom"), __webpack_require__.e("src_App_scss-src_ZeusDSConfig_index_tsx-src_router_dev-router_ts"), __webpack_require__.e("src_App_tsx")]).then(() => (() => ((__webpack_require__(/*! ./src/App.tsx */ "./src/App.tsx")))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});